import React 			from 'react';
import ReactDOM 		from 'react-dom';

import BLComponent		from '../../core/_BLComponent.jsx';
import CrowdfundingCountdown 	from './_CrowdfundingCountdown.jsx';

export default class CrowdfundingHeaderClock extends BLComponent {
	constructor(props, context) {
		super(props, context);
	}

	returnActiveSeries() {
		const {series} = this.props;
		let newSeriesNotice = new Date(blapp.config.server_time);
				newSeriesNotice.setDate(newSeriesNotice.getDate() + 42);
		let activeSeries;

		for(let i = 0; i < series.length; i++) {
			let oneWeekAfter = new Date(series[i].udtCrowdSourcingEnd);
					oneWeekAfter.setDate(oneWeekAfter.getDate() + 7);

			if(newSeriesNotice.getTime() >= series[i].udtCrowdSourcingStart) {
				activeSeries = series[i];

				break;
			}else if(series[i].udtCrowdSourcingStart <= blapp.config.server_time) {
				activeSeries = series[i];

				break;
			}else if(oneWeekAfter.getTime() <= blapp.config.server_time) {
				activeSeries = series[i];

				break;
			}
		}

		return activeSeries ? activeSeries : series[0];
	}

	render() {
		const series = this.returnActiveSeries();
		const {phase} = series;
		const closed = phase == 'PRE_VALIDATION' || phase == 'VALIDATION' || phase == 'POST_VALIDATION' || phase == 'FINALIST' || phase == 'CLOSED' || phase == 'WAITING';

		let newSeriesNotice = new Date(blapp.config.server_time);
				newSeriesNotice.setDate(newSeriesNotice.getDate() + 42);
		let oneWeekAfter = new Date(series.udtCrowdSourcingEnd);
				oneWeekAfter.setDate(oneWeekAfter.getDate() + 7);

		if(newSeriesNotice.getTime() >= series.udtCrowdSourcingStart && blapp.config.server_time <= series.udtCrowdSourcingStart) {
			return (
				<article className={"crowd-guidelines__head container"}>
					<div className="crowd-guidelines__head-internal container__internal">
						<h2 className="crowd-guidelines__head-title">Submit your design in:</h2>
						<CrowdfundingCountdown classes="crowd-guidelines__clock" end={series.udtCrowdSourcingStart}/>
					</div>
				</article>
			);
		}else if(oneWeekAfter.getTime() <= blapp.config.server_time) {
			return null;
		}else if(phase == "INTAKE") {
			return (
				<article className={"crowd-guidelines__head container crowd-guidelines__head--intake"}>
					<div className="crowd-guidelines__head-internal container__internal">
						<div className="crowd-guidelines__countdown-open-intro">
							<h2 className="crowd-guidelines__head-title">{`Submissions for ${series.strName} are now open!`}</h2>
							{!this.props.noSubmitCta && <a href={blapp.url2.getCrowdProjectSubmissionsUrl()} className="l-inline-block btn btn--yellow text--bold l-margin-top">Submit design<i className="fas fa-long-arrow-right l-margin-left--sm"/></a>}
						</div>
						<div className="crowd-guidelines__countdown-open">
							<h2 className="crowd-guidelines__countdown-open-title">Submissions close in:</h2>
							<CrowdfundingCountdown classes="crowd-guidelines__clock" end={series.udtCrowdSourcingEnd}/>
						</div>
					</div>
				</article>
			);
		}else if(closed) {
			return (
				<article className={"crowd-guidelines__head container crowd-guidelines__head--closed"}>
					<div className="crowd-guidelines__head-internal container__internal">
						<h2 className="crowd-guidelines__head-title">{`Submissions for ${series.strName} are now closed!`}</h2>
					</div>
				</article>
			);
		}else{
			return (
				<article className={"crowd-guidelines__head container crowd-guidelines__head--closed"}>
					<div className="crowd-guidelines__head-internal container__internal">
						<h2 className="crowd-guidelines__head-title">{`Submissions for ${series.strName} are now closed!`}</h2>
					</div>
				</article>
			);
		}
	}
}